import React, { FC } from "react";

import { UploadAttributes } from "./UploadAttributes";
import { UploadFiles } from "./UploadFiles";
import { UploadTiling } from "./UploadTiling";
import { useUploadDataContext } from "../uploadDataContext";
import { UploadFileStep } from "../types";

export const UploadSteps: FC = () => {
  const { step } = useUploadDataContext();

  switch (step) {
    case UploadFileStep.Attributes:
      return <UploadAttributes />;
    case UploadFileStep.Tiling:
      return <UploadTiling />;
    case UploadFileStep.Files:
    default:
      return <UploadFiles />;
  }
};
